import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ButtonComponentModule} from 'app/components/ui/button/item.module';
import {DirectivesModule} from 'app/core/directives/directives.module';
import {InputComponentModule} from 'app/components/form/input/item.module';
import {TextareaComponentModule} from 'app/components/form/textarea/item.module';
import {ChatInputFieldComponent} from 'app/components/ui/chat/chat-input-field/item';
import {ChatWrapperComponent} from 'app/components/ui/chat/chat-wrapper/item';
import {ChatHeaderComponent} from 'app/components/ui/chat/chat-header/item';
import {ChatReplyMessageComponent} from 'app/components/ui/chat/chat-reply-message/item';
import {IconComponentModule} from 'app/components/ui/icon/item.module';
import {ChatMessageComponent} from 'app/components/ui/chat/chat-message/item';
import {ChatInfoMessageComponent} from 'app/components/ui/chat/chat-info-message/item';
import {ChatDateMessageComponent} from 'app/components/ui/chat/chat-date-message/item';
import {ChatFixedInputComponent} from 'app/components/ui/chat/chat-fixed-input/item';
import {ReactiveFormsModule} from '@angular/forms';
import {ChatModalModule} from 'app/components/shared/chatModal/item.module';
import {FileComponentModule} from 'app/components/form/file/item.module';
import {MediaUploadModalModule} from 'app/components/shared/mediaUploadModal/item.module';
import {BlocksComponentModule} from 'app/components/blocks/item.module';
import {ChatScrollbarComponent} from 'app/components/ui/chat/chat-scrollbar/item';
import {FileItemsComponentModule} from 'app/components/ui/file-items/item.module';
import {ChatPinedMessageComponent} from 'app/components/ui/chat/chat-pined-message/item';
import {AvatarComponentModule} from '../avatar/item.module';
import {ChatObserverDirective} from './chat-observer/chat-observer.directive';
import {LoaderComponentModule} from "../loader/item.module";
import {EmptyOrNoAccessComponentModule} from "../empty-or-noaccess/item.module";
import {CounterComponentModule} from "../counter/item.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ButtonComponentModule,
    DirectivesModule,
    InputComponentModule,
    TextareaComponentModule,
    IconComponentModule,
    ReactiveFormsModule,
    ChatModalModule,
    FileComponentModule,
    MediaUploadModalModule,
    BlocksComponentModule,
    FileItemsComponentModule,
    AvatarComponentModule,
    LoaderComponentModule,
    EmptyOrNoAccessComponentModule,
    CounterComponentModule,
  ],
  exports: [
    ChatInputFieldComponent,
    ChatWrapperComponent,
    ChatHeaderComponent,
    ChatReplyMessageComponent,
    ChatMessageComponent,
    ChatInfoMessageComponent,
    ChatDateMessageComponent,
    ChatFixedInputComponent
  ],
  declarations: [
    ChatInputFieldComponent,
    ChatWrapperComponent,
    ChatHeaderComponent,
    ChatReplyMessageComponent,
    ChatMessageComponent,
    ChatInfoMessageComponent,
    ChatDateMessageComponent,
    ChatFixedInputComponent,
    ChatScrollbarComponent,
    ChatPinedMessageComponent,
    ChatObserverDirective
  ],
  providers: [],
})
export class ChatInputFieldModule {
}
